export const alphabeticalOnlyRegex = /^[A-Za-z]*$/;
export const alphabeticalOnlyRegexWithSpaces = /^[A-Za-z ]*$/;
